"use client";

import React, { useEffect, useState } from "react";

import Loader from "../common/LoaderComponent"; // optional, remove if not used
import { PromotionalMessage } from "@/packages/types/general";
import { fetchSiteFeatures } from "@/api-service/general";

const SiteFeature: React.FC = () => {
  const [features, setFeatures] = useState<PromotionalMessage[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const loadFeatures = async () => {
      try {
        const data = await fetchSiteFeatures();
        setFeatures(data || []);
      } catch (error) {
        console.error("Error fetching site features:", error);
      } finally {
        setLoading(false);
      }
    };
    loadFeatures();
  }, []);

  if (loading) {
    return (
      <div className="max-w-7xl mx-auto bg-[#FBBF24] text-white py-2 mt-5 mb-5 flex items-center justify-center">
        <Loader label="Loading site features..." size="sm" />
      </div>
    );
  }

  if (features.length === 0) {
    return null;
  }

  return (
    <div className="max-w-7xl mx-auto overflow-hidden bg-[#FBBF24] text-white py-2 mt-5 mb-5">
      <div className="whitespace-nowrap animate-marquee text-sm font-medium flex gap-12">
        {features.concat(features).map((feature, index) => (
          <span key={index} className="px-4">
            {feature.message.toUpperCase()}
          </span>
        ))}
      </div>
    </div>
  );
};

export default SiteFeature;
